import { FC } from "react";
import { useParams } from "react-router-dom";

const HostShow: FC = () => {
  const { id } = useParams();
  return <div>Page of host #{id}</div>;
};

export default HostShow;
